import styled from 'styled-components';

export const Container = styled.div`
  float: left;
  display: flex;
  flex-direction: column;
  font-size: 1.6rem;
  font-weight: 500;
  color: #ff2f2f;
  width: 100%;
  background: #ffe8ec;
  padding: 3rem;
  border-color: #ff2f2f;
  border-style: dashed;
  text-align: left;
  border-radius: 0.8rem;
  margin: 0 0 2rem 0;

  @media (max-width: 1024px) {
    max-width: 100%;
    font-size: 1rem;
  }
`;
